import { render } from "./mobile_draw_field.vue?vue&type=template&id=48c6e30d"
import script from "./mobile_draw_field.vue?vue&type=script&lang=js"
export * from "./mobile_draw_field.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__